// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Router from 'vue-router'
import App from './App';
import router from './router';
import store from './store';
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './icons' // icon
// css
import '@/assets/css/bootstrap.css';
import '@/assets/css/font-awesome.css';
import '@/assets/css/owl.carousel.min.css';
import '@/assets/css/owl.theme.default.min.css';
import '@/assets/css/style.css';
import '@/assets/css/single-page.css';
import '@/assets/css/rotator.css';

//js
import '@/assets/js/jquery.js';
import '@/assets/js/bootstrap.js';
import '@/assets/js/jquery.nav.js';
// import '@/assets/js/rotator.js';
// import '@/assets/js/owl.carousel.min.js';
import '@/assets/js/script.js';

import moment from 'moment';
Vue.prototype.$moment = moment; //赋值使用
moment.locale('zh-cn'); //需要汉化

import VueCropper from 'vue-cropper'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
console.log(process.env)
Vue.use(VueCropper)
Vue.use(Element, { size: 'small', zIndex: 3000 });

Vue.config.productionTip = false

Vue.prototype.institutionConfig = process.env.institutionConfig;
window.institutionConfig = process.env.institutionConfig;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js